import React from 'react';
import { values, ceo } from '../data/mock';
import { Card, CardContent } from './ui/card';
import { Shield, Target, Sparkles, Handshake, Quote } from 'lucide-react';

const iconMap = {
  Shield: Shield,
  Target: Target,
  Sparkles: Sparkles,
  Handshake: Handshake
};

const AboutSection = () => {
  return (
    <section id="about" className="relative py-24 lg:py-32 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 bg-slate-900">
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-cyan-950/30 via-slate-900 to-slate-900" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-1.5 rounded-full bg-cyan-500/10 border border-cyan-500/20 text-cyan-400 text-sm font-medium mb-4">
            Quem Somos
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-6">
            Tecnologia com{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-teal-400">
              propósito
            </span>
          </h2>
          <p className="text-lg text-slate-400 max-w-2xl mx-auto">
            Acreditamos na Tecnologia da Informação como patrimônio estratégico das Organizações,
            gerando vantagens competitivas através de soluções inteligentes.
          </p>
        </div>

        {/* Values Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-20">
          {values.map((value, index) => {
            const Icon = iconMap[value.icon];
            return (
              <Card
                key={index}
                className="bg-slate-800/50 border-slate-700/50 hover:border-cyan-500/30 transition-all duration-300 group"
              >
                <CardContent className="p-6">
                  <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-cyan-500/20 to-teal-500/20 flex items-center justify-center mb-4 group-hover:from-cyan-500/30 group-hover:to-teal-500/30 transition-all">
                    {Icon && <Icon className="h-6 w-6 text-cyan-400" />}
                  </div>
                  <h3 className="text-lg font-semibold text-white mb-2">{value.title}</h3>
                  <p className="text-sm text-slate-400">{value.description}</p>
                </CardContent>
              </Card>
            );
          })}
        </div>

        {/* CEO Section */}
      



<div className="grid md:grid-cols-3 gap-10 items-start">
  
  {/* FOTO */}
  <div className="md:col-span-1">
    <img
      src={ceo.image}
      alt={ceo.name}
      className="w-full h-full rounded-2xl object-cover"
    />
     <div className="absolute inset-0 bg-gradient-to-t from-slate-900/30  via-transparent to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-6">
                <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-cyan-500/20 border border-cyan-500/30 mb-2">
                  <span className="w-2 h-2 rounded-full bg-cyan-400" />
                  <span className="text-cyan-400 text-xs font-medium">{ceo.role}</span>
                </div>
                <h3 className="text-2xl font-bold text-white">{ceo.name}</h3>
              </div>
  </div>

  {/* TEXTO */}
  <div className="md:col-span-2 space-y-8 mt-20">
    
    <blockquote className="relative text-xl text-slate-300 italic leading-relaxed pl-8">
      "Chave de sucesso nos negócios: perceber para onde o mundo está indo e chegar lá primeiro"
      <p className="text-cyan-400 mt-4">— Bill Gates</p>
    </blockquote>

    <div className="bg-slate-800/50 rounded-xl border border-slate-700/50 p-6">
      <h4 className="text-lg font-semibold text-white mb-4">
        Sobre o Fundador
      </h4>

      <p className="text-slate-400 leading-relaxed">
        {ceo.bio}
      </p>
    </div>

  </div>
</div>









      </div>
    </section>
  );
};

export default AboutSection;
